import styles from "./Experience.module.sass";
import Card from "../../components/Card";
import cn from "classnames";
import { UseApi } from "../../hooks/use-api";
import { GetExperienceList } from "../../Services/lib/admin";
import Table from "../Redeem/Table";
import { useEffect, useState } from "react";
import { UseDisclosure } from "../../hooks/use-disclosure";
import ExperienceModal from "./Modal";
import QrReader from "./QrReader";
import Form from "../../components/Form";
import redeem from "../../i11/Redeem";
import { useUser } from "../../context";
const LIMIT = 8;

const Experience = () => {
	const { locale } = useUser();
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [search, setSearch] = useState("");
	const {
		isOpen: openQr,
		onClose: onCloseQr,
		onOpen: onOpenQr,
	} = UseDisclosure();
	const [{ isLoading }, getExperienceList] = UseApi({
		service: GetExperienceList,
	});
	const [nft, setNFT] = useState();
	const [page, setPage] = useState(1);
	const [total, setTotal] = useState(1);
	const [data, setData] = useState([]);
	const getList = async () => {
		setData([]);
		const res = await getExperienceList({
			limit: LIMIT,
			skip: page,
			search,
		});
		if (res) {
			setData(res.data);
			setTotal(Math.ceil(res.count / LIMIT));
		}
	};
	const refetch = () => {
		getList();
	};

	useEffect(() => {
		getList();
	}, [page]);

	const close = () => {
		setNFT();
		getList();
		onClose();
	};

	const onSubmit = (e) => {
		e.preventDefault();
		getList();
	};

	const open = (data_) => {
		setNFT(data_);
		onOpen();
	};

	const prop = { data, getList, isLoading, page, setPage, total };

	return (
		<Card
			title={redeem[locale].experience}
			classTitle={cn("title-purple", styles.title)}
			classCardHead={cn(styles.head)}
			head={
				<>
					<Form
						placeholder={redeem[locale].exp_search_placeHolder}
						type="text"
						name="search"
						icon="search"
						className={styles.leftMargin}
						required={false}
						value={search}
						setValue={setSearch}
						onSubmit={onSubmit}
					/>
					<button
						onClick={onOpenQr}
						type="button"
						className={cn("button-small", styles.leftMargin)}
					>
						{redeem[locale].access}
					</button>
				</>
			}
		>
			<Table open={open} exp {...prop} />
			{nft && (
				<ExperienceModal
					refetch={refetch}
					visible={isOpen}
					onClose={close}
					data={nft}
				/>
			)}
			{openQr && <QrReader visible={openQr} onClose={onCloseQr} />}
		</Card>
	);
};

export default Experience;
